module.exports = __webpack_public_path__ + "static/img/3245_phase_function_Paper_PointsHejduk_Prediction.a6bcb82.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/3245_phase_function_Paper_PointsHejduk_Prediction.png
// module id = wcov
// module chunks = 0